import React from 'react';

import Reconnecter from './Reconnecter';

type Props = {
  isMarkdownExercise?: boolean;
};

const ShowReconnectorIfRequired: React.FC<Props> = ({ isMarkdownExercise }) => {
  if (isMarkdownExercise) {
    return <Reconnecter />;
  }
  return null;
};

export default ShowReconnectorIfRequired;
